import type { AppState } from '@autoday/core';

/** Äldre export än så får en diskret påminnelse om att hämta en ny. Inga datum hittas på. */
export const STALE_IMPORT_DAYS = 30;

export interface SourceFreshness {
  id: string;
  name: string;
  lastImportAt: string;
  ageDays: number;
  stale: boolean;
}

/** Senaste gällande (ej ångrade) import per källa, nyast först. Källor utan gällande import utelämnas. */
export function sourceFreshness(state: Pick<AppState, 'sources'>, nowMs: number): SourceFreshness[] {
  return Object.values(state.sources)
    .flatMap((s) => {
      const last = s.imports.filter((r) => !r.undone).at(-1);
      if (!last) return [];
      const ageDays = Math.max(0, Math.floor((nowMs - Date.parse(last.at)) / 86_400_000));
      return [{ id: s.id, name: s.name, lastImportAt: last.at, ageDays, stale: ageDays > STALE_IMPORT_DAYS }];
    })
    .sort((a, b) => b.lastImportAt.localeCompare(a.lastImportAt));
}
